import { useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { LogoLockup, BoutiqueStaysLockup } from "./Logo";
import MobileNav from "./MobileNav";
import WishlistLink from "./WishlistLink";
import HeaderUserMenu from "./HeaderUserMenu";
import LanguageToggle from "./LanguageToggle";
import { StaysIcon, FurnishIcon, ExperiencesIcon } from "./NavIcons";
import SectionTabs, { SectionTabsSpacer } from "./SectionTabs";
import { brand } from "@/lib/brand";

export default function Header() {
  const t = useTranslations("nav");

  return (
    <>
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-md border-b border-ss-line">
        {/* Solid on phones so the section-tab row (SectionTabs) slides away *under* the bar. */}
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 h-[70px] flex items-center justify-between gap-3 md:gap-4 bg-white md:bg-transparent">
          <Link href="/" className="flex items-center flex-none" aria-label={t("homeAriaLabel")}>
            {brand.id === "boutique-stays" ? (
              <BoutiqueStaysLockup size={22} />
            ) : (
              <LogoLockup size={22} />
            )}
          </Link>

          {/* Three tabs, own icons (NavIcons.tsx), same as the furnish branch's
              header: Stays (key), Furnish (armchair), Experiences (compass).
              Experiences went live 2026-09-28 (OceanAir catalogue); Contact
              moved out of the top bar into the menu/footer. */}
          <nav className="hidden md:flex items-center gap-1 absolute left-1/2 -translate-x-1/2">
            <Link
              href="/search"
              className="px-3.5 py-2 rounded-full text-[14px] font-semibold text-ss-text hover:bg-ss-bg-soft transition-colors inline-flex items-center gap-1.5"
            >
              <StaysIcon />
              {t("stays")}
            </Link>
            <Link
              href="/furnish"
              className="px-3.5 py-2 rounded-full text-[14px] font-semibold text-ss-text hover:bg-ss-bg-soft transition-colors inline-flex items-center gap-1.5"
            >
              <FurnishIcon />
              {t("furnish")}
            </Link>
            <Link
              href="/experiences"
              className="px-3.5 py-2 rounded-full text-[14px] font-semibold text-ss-text hover:bg-ss-bg-soft transition-colors inline-flex items-center gap-1.5"
            >
              <ExperiencesIcon />
              {t("experiences")}
            </Link>
          </nav>

          <div className="flex items-center gap-2.5 flex-none">
            {/* Language toggle: hidden for boutique-stays (English-only brand) */}
            {brand.id !== "boutique-stays" && (
              <LanguageToggle className="inline-flex text-[13px] md:text-sm font-semibold text-ss-text hover:text-ss-blue transition-colors whitespace-nowrap" />
            )}
            <WishlistLink className="hidden md:inline-flex" />
            <HeaderUserMenu />
            <MobileNav />
          </div>
        </div>
        <SectionTabs />
      </header>
      <SectionTabsSpacer />
    </>
  );
}
